import { render, staticRenderFns } from "./iframepage.vue?vue&type=template&id=4712e9ec&scoped=true"
import script from "./iframepage.vue?vue&type=script&lang=js"
export * from "./iframepage.vue?vue&type=script&lang=js"
import style0 from "./iframepage.vue?vue&type=style&index=0&id=4712e9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712e9ec",
  null
  
)

export default component.exports